import { Column } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { FaireLogo } from "@faire/web/ui/logos/FaireLogo";
import * as React from "react";
import styled from "styled-components";

export const LoginWrapper: React.FC<{
  children: React.ReactNode;
  noSpacing?: boolean;
}> = ({ children, noSpacing }) => {
  return (
    <Wrapper>
      <div className="hidden flex-row md:flex">
        <Spacer size={4} />
        <FaireLogo size={88} />
      </div>
      {noSpacing ? null : <Spacer size="4x" className="hidden md:block" />}
      {children}
    </Wrapper>
  );
};

const Wrapper = styled(Column)`
  padding: ${getSpacing("5x", "3x", "8x", "3x")};
  margin-bottom: ${getSpacing("8x")};
  ${responsiveMediaQueries.tabletAndAbove} {
    margin: auto;
    min-height: 480px;
    width: 420px;
    padding: ${getSpacing("5x")};
  }
`;
